import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../utils/routes';
import './Contact.css';
import { UK_OFFICE, mapsUrl } from "../../utils/offices";
const contactBanner = process.env.PUBLIC_URL + '/images/contact/contact.jpg';

const inquiryTypes = [
  'SAP Solutions',
  'Data & Analytics',
  'AI & Automation',
  'Technology Ecosystem',
  'Careers',
  'General Inquiry',
];

export default function Contact() {
  const navigate = useNavigate();

  const handleNavigateHome = () => {
    navigate(ROUTES.HOME);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    inquiryType: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = new FormData();

      data.append("name", formData.name);
      data.append("email", formData.email);
      data.append("company", formData.company);
      data.append("phone_number", formData.phone_number);
      data.append("inquiry", formData.inquiry);
      data.append("message", formData.message);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/submit-contact`,
        {
          method: "POST",
          headers: {
            "api-username": process.env.REACT_APP_API_URL_USERNAME,
            "api-password": process.env.REACT_APP_API_URL_PASSWORD,
            "Accept": "application/json"
          },
          body: data
        }
      );
      const result = await response.json();

      console.log(result);

      if (result.status === true) {
        setSubmitted(true);
        setFormData({
          name: "",
          email: "",
          company: "",
          phone_number: "",
          inquiry: "",
          message: ""
        });
      } else {
        setErrors(result.errors || {});
      }

    } catch (error) {
      console.log(error);
    }
  };
  const [contactData, setContactData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/contact-page`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-username": `${process.env.REACT_APP_API_URL_USERNAME}`,
        "api-password": `${process.env.REACT_APP_API_URL_PASSWORD}`
      },
      body: JSON.stringify({})
    })
      .then((response) => response.json())
      .then((data) => {
        setContactData(data.site_settings);
      })
      .catch((error) => {
        console.log(error);
      }).finally(() => {
        setLoading(false);
      });
  }, []);
  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <>
      {/* ── Banner ── */}
      <section className="contact-banner inner-page-banner" style={{ backgroundImage: `url(${contactBanner})` }}>
        <div className="contact-banner-overlay inner-page-banner-overlay" />
        <div className="container contact-banner-inner inner-page-banner-inner">
          <h1 className="inner-page-banner-title">Contact Us</h1>
        </div>
      </section>

      <div className="inner-page-breadcrumb-wrap">
        <div className="container">
          <nav className="inner-page-breadcrumb">
            <button type="button" className="inner-page-home" onClick={handleNavigateHome}>Home</button>
            <span className="inner-page-sep"><i className="bi bi-chevron-right" /></span>
            <span className="inner-page-current">Contact Us</span>
          </nav>
        </div>
      </div>

      {/* ── Main Content ── */}
      <section className="contact-section">
        <div className="container">

          {/* Intro */}
          <div className="contact-intro" data-aos="fade-up">
            <h2 className="contact-heading">Let's discuss your transformation priorities</h2>
            <p className="contact-subtext">
              Whether you are planning an SAP modernization, data platform strategy, AI roadmap,
              or broader enterprise transformation initiative, our team is ready to connect.
            </p>
          </div>

          {/* ── 3-Column Info Cards ── */}
          <div className="row g-3 g-lg-4 contact-info-row" data-aos="fade-up">
            <div key="Our Office" className="col-lg-3 col-md-6 col-sm-12">
              <div className="ci-card">
                <div className="ci-card-icon">
                  <i className="bi bi-geo-alt-fill" />
                </div>
                <div className="ci-card-body">
                  <span className="ci-card-label">US Office</span>
                  {contactData.company_address ? (
                    <a href={mapsUrl(contactData.company_address)} className="ci-card-value" target="_blank" rel="noreferrer">{contactData.company_address}</a>
                  ) : (
                    <p className="ci-card-value">{contactData.company_address}</p>
                  )}
                </div>
              </div>
            </div>
            <div key="UK Office" className="col-lg-3 col-md-6 col-sm-12">
              <div className="ci-card">
                <div className="ci-card-icon">
                  <i className="bi bi-geo-alt-fill" />
                </div>
                <div className="ci-card-body">
                  <span className="ci-card-label">{UK_OFFICE.label}</span>
                  <a href={mapsUrl(UK_OFFICE.address)} className="ci-card-value" target="_blank" rel="noreferrer">
                    {UK_OFFICE.company}, {UK_OFFICE.address}
                  </a>
                </div>
              </div>
            </div>
            <div key="Email Us" className="col-lg-3 col-md-6 col-sm-12">
              <div className="ci-card">
                <div className="ci-card-icon">
                  <i className="bi-envelope-fill" />
                </div>
                <div className="ci-card-body">
                  <span className="ci-card-label">Email Us</span>
                  {contactData.email ? (
                    <a href={contactData.email} className="ci-card-value">{contactData.email}</a>
                  ) : (
                    <p className="ci-card-value">{contactData.email}</p>
                  )}
                </div>
              </div>
            </div>
            <div key="Call Us" className="col-lg-3 col-md-6 col-sm-12">
              <div className="ci-card">
                <div className="ci-card-icon">
                  <i className="bi-telephone-fill" />
                </div>
                <div className="ci-card-body">
                  <span className="ci-card-label">Call Us</span>
                  {contactData.phone_number ? (
                    <a href={`tel:${contactData.phone_number}`} className="ci-card-value">{contactData.phone_number}</a>
                  ) : (
                    <p className="ci-card-value">{contactData.phone_number}</p>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* ── Centered Form ── */}
          <div className="row justify-content-center contact-form-row">
            <div className="col-lg-9 col-md-10" data-aos="fade-up">
              <div className="contact-form-card">
                {submitted ? (
                  <div className="contact-success">
                    <div className="success-icon"><i className="bi bi-check-circle-fill" /></div>
                    <h3>Thank you!</h3>
                    <p>Your message has been received. Our team will be in touch with you shortly.</p>
                    <button className="btn-contact-submit" onClick={() => setSubmitted(false)}>
                      Send Another Message
                    </button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div className="row g-2 g-lg-4">
                      <div className="col-sm-6">
                        <label className="cf-label">Full Name <span>*</span></label>
                        <input
                          type="text"
                          name="name"
                          className="cf-input"
                          placeholder="Enter your full name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                        {errors.name && (
                          <span className="text-danger">
                            {errors.name[0]}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-6">
                        <label className="cf-label">Company <span>*</span></label>
                        <input
                          type="text"
                          name="company"
                          className="cf-input"
                          placeholder="Enter your company name"
                          value={formData.company}
                          onChange={handleChange}
                          required
                        />
                        {errors.company && (
                          <span className="text-danger">
                            {errors.company[0]}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-6">
                        <label className="cf-label">Email Address <span>*</span></label>
                        <input
                          type="email"
                          name="email"
                          className="cf-input"
                          placeholder="Enter your email address"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                        {errors.email && (
                          <span className="text-danger">
                            {errors.email[0]}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-6">
                        <label className="cf-label">Phone Number</label>
                        <input
                          type="tel"
                          name="phone_number"
                          className="cf-input"
                          placeholder="Enter your phone number"
                          value={formData.phone_number}
                          onChange={handleChange}
                        />
                        {errors.phone_number && (
                          <span className="text-danger">
                            {errors.phone_number[0]}
                          </span>
                        )}
                      </div>
                      <div className="col-12">
                        <label className="cf-label">Inquiry Type <span>*</span></label>
                        <div className="cf-select-wrap">
                          <select
                            name="inquiry"
                            className="cf-input cf-select"
                            value={formData.inquiry}
                            onChange={handleChange}
                            required
                          >
                            <option value="" disabled>Select an inquiry type</option>
                            {inquiryTypes.map((type) => (
                              <option key={type} value={type}>{type}</option>
                            ))}
                          </select>
                          <i className="bi bi-chevron-down cf-select-icon" />
                        </div>
                        {errors.inquiry && (
                          <span className="text-danger">
                            {errors.inquiry[0]}
                          </span>
                        )}
                      </div>
                      <div className="col-12">
                        <label className="cf-label">Message <span>*</span></label>
                        <textarea
                          name="message"
                          className="cf-input cf-textarea"
                          placeholder="Tell us about your project or inquiry..."
                          rows={5}
                          value={formData.message}
                          onChange={handleChange}
                          required
                        />
                        {errors.message && (
                          <span className="text-danger">
                            {errors.message[0]}
                          </span>
                        )}
                      </div>
                      <div className="col-12 text-center">
                        <button type="submit" className="btn-contact-submit">
                          Send Message
                        </button>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
